import React from 'react';
import { TipMessage as UITipMessage } from '@shopee/chatbot-ui';
import { MessageProps } from '@shopee/chatbot-ui/lib/components/Message';

const TipMessage: React.FC<MessageProps> = (props) => {
  return <UITipMessage {...props} />;
};

export default TipMessage;
